// @ts-nocheck
import * as _ from 'lodash';
import {
  SlickGridModel,
  SlickPlugin,
  Formatter,
  Column,
  SlickEvent,
  OnSelectedRowsChangedEventArgs,
  OnClickEventArgs,
  OnHeaderClickEventArgs,
  OnKeyDownEventArgs,
  SlickEventHandler,
  SlickRowSelectionModel,
  Utils,
} from 'slickgrid';

interface SelectionChangedEventArgs<T> {
  row: number;
  data: T;
}

interface CheckboxColumnOptions {
  headerSelect: boolean;
  readOnly?: boolean;
  rowSelector?: boolean;
  onSelectionChanged?(args: SelectionChangedEventArgs): void;
}

const DEFAULTS = {
  id: '_checkbox_selector',
  name: '',
  field: '$selected',
  toolTip: '',
  cssClass: '',
  width: 30,
  rowSelector: true, // column for grid row selection
  frozen: true,
  systemColumn: true,
  filterable: false,
  resizable: false,
  sortable: false,
  hideable: false,
  headerSelect: true,
  readOnly: false,
};

export class CheckboxColumn<T> implements SlickPlugin, Column<T> {
  pluginName = 'CheckboxColumn' as const;

  private readonly eventHandler: SlickEventHandler;
  private grid: SlickGridModel<T>;
  private selectedRows: Dictionary<boolean>;

  // readonly options: CheckboxColumnOptions<T>;

  id: string;
  name?: string;
  field: string;
  rowSelector: boolean;

  headerCssClass?: string;
  maxWidth?: number;
  minWidth?: number;
  rerenderOnResize?: boolean;
  resizable?: boolean;
  selectable?: boolean;
  sortable: boolean;
  hideable: boolean;
  toolTip?: string;
  width?: number;

  onSelectionChanged?: (args: SelectionChangedEventArgs<T>) => void;

  constructor(options?: CheckboxColumnOptions<T>) {
    this.eventHandler = new SlickEventHandler();
    this.selectedRows = {};
    _.extend(this, this.getColumnOptions({ ...DEFAULTS, ...options }));
  }

  public init(grid: SlickGridModel<T>): void {
    this.grid = grid;

    if (this.rowSelector) {
      const rowSelection = new SlickRowSelectionModel({
        selectActiveRow: false,
      });
      grid.registerPlugin(rowSelection);
      grid.setSelectionModel(rowSelection);

      this.eventHandler.subscribe(
        grid.onSelectedRowsChanged,
        this.onSelectedRowsChanged.bind(this),
      );
    }

    this.eventHandler
      .subscribe(grid.onClick, this.onClick.bind(this))
      .subscribe(grid.onHeaderClick, this.onHeaderClick.bind(this))
      .subscribe(grid.onKeyDown, this.onKeyDown.bind(this));
  }

  public destroy(): void {
    this.eventHandler.unsubscribeAll();
  }

  /**
   *  grid selected rows changed handler
   */
  private onSelectedRowsChanged(
    e: SlickEvent,
    args: OnSelectedRowsChangedEventArgs,
  ) {
    const grid = args.grid,
      selection = grid.getSelectedRows();

    // let
    //    lookup: Dictionary<boolean> = {},
    //    payload: {
    //      rowsAdded?: number[],
    //      rowsRemoved?: number[]
    //    } = {};  // eventargs to transmit

    //  for (let row of selection) {
    //    lookup[row] = true;

    //   if (_.isUndefined(this.selectedRows[row])) {
    //     // this is a new selection
    //     (payload.rowsAdded || (payload.rowsAdded = [])).push(row);
    //     grid.invalidateRow(row);
    //   }

    //   delete this.selectedRows[row];
    // }

    // // the remaining contains the deselected rows
    // for (let row of _.keys(this.selectedRows)) {
    //   const rowNum = parseInt(row);

    //   grid.invalidateRow(rowNum);
    //   (payload.rowsRemoved || (payload.rowsRemoved = [])).push(rowNum);
    // }

    // this.selectedRows = lookup;
    // grid.render();

    this.updateColumnHeader(selection.length === grid.getDataLength());

    // selectionChanged.notify(payload);
  }

  private updateColumnHeader(checked: boolean) {
    const extras = checked ? ' checked="checked"' : '';

    this.grid.updateColumnHeader(
      this.id,
      `<input type="checkbox"${extras}>`,
      this.toolTip,
    );
  }

  private onClick(e: Event, args: OnClickEventArgs) {
    // clicking on a row selects checkbox

    if ((e.target as HTMLInputElement).type !== 'checkbox') {
      return;
    }

    if (!this.isThisColumn(args.cell)) {
      return;
    }

    if (
      args.grid.getEditorLock().isActive(null) &&
      !args.grid.getEditorLock().commitCurrentEdit()
    ) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    this.toggleRowSelection(args.row);
    e.stopPropagation();
    e.stopImmediatePropagation();
  }

  private onHeaderClick(e: Event, args: OnHeaderClickEventArgs) {
    if ((e.target as HTMLInputElement).type !== 'checkbox') {
      return;
    }

    if (args.column.id !== this.id) {
      return;
    }

    if (
      args.grid.getEditorLock().isActive(null) &&
      !args.grid.getEditorLock().commitCurrentEdit()
    ) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    const selected = (e.target as HTMLInputElement).checked,
      field = this.field,
      selectedRows: number[] = [];

    for (let i = 0; i < args.grid.getDataLength(); i++) {
      const data = this.grid.getDataItem(i);
      if (data[field] !== selected) {
        data[field] = selected;
      }

      if (selected) {
        selectedRows.push(i);
      }
    }

    e.stopPropagation();
    e.stopImmediatePropagation();

    this.grid.setSelectedRows(selectedRows);
    this.grid.invalidateAllRows();
    this.grid.render();
  }

  // private setRowSelection(row: number, selected: boolean) {
  //   const
  //     data = this.grid.getDataItem(row),
  //     field = this.field;

  //   if (data[field] !== selected) {
  //     data[field] = selected;

  //     if (this.rowSelector) {

  //     }
  //     else {
  //       this.emitSelectionChanged({ row, data });
  //     }
  //   }
  // }

  private onKeyDown(e: KeyboardEvent, args: OnKeyDownEventArgs) {
    // toggle on space
    if (e.which === 32 && this.isThisColumn(args.cell)) {
      // if editing, try to commit
      if (
        !args.grid.getEditorLock().isActive(null) ||
        args.grid.getEditorLock().commitCurrentEdit()
      ) {
        this.toggleRowSelection(args.row);
      }
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }

  private getColumnOptions(options: CheckboxColumnOptions<T>): Column<T> {
    const result = { ...options };

    if (options.headerSelect) {
      result.name = result.name
        ? `<label><input type="checkbox"> ${result.name}</label>`
        : '<input type="checkbox">';
    }

    if (options.toolTip) {
      result.toolTip = 'Select/Deselect All';
    }

    result.formatter = getFormatter(options);

    return result;
  }

  private toggleRowSelection(row: number) {
    const data = this.grid.getDataItem(row),
      selected = !data[this.field];

    data[this.field] = selected;

    if (this.rowSelector) {
      const selectedRows = this.grid.getSelectedRows();

      this.grid.setSelectedRows(
        selected ? selectedRows.concat(row) : _.without(selectedRows, row),
      );
    } else {
      this.grid.invalidateRow(row);
      this.grid.render();
      this.emitSelectionChanged({ row, data });
    }
  }

  private isThisColumn(cell: number) {
    const column = this.grid.getColumns()[cell];
    return column && column.id === this.id;
  }

  private emitSelectionChanged(args: { row: number; data: T }) {
    if (this.onSelectionChanged) {
      this.onSelectionChanged(args);
    }
  }
}

function getFormatter<T>(options: CheckboxColumnOptions<T>): Formatter<T> {
  const extras = options.readOnly
      ? ' tabindex="-1" style="pointer-events: none"'
      : '',
    tpl_truthy = '<input type="checkbox" checked="checked">',
    tpl_falsy = `<input type="checkbox" ${extras}>`;

  return function checkboxFormatter(row, cell, value, columnDef, data) {
    return data ? (value ? tpl_truthy : tpl_falsy) : null;
  };
}
